<template>
  <div class="flex justify-between items-center z-50">
      <NuxtLink to="/" class="flex font-mono text-24 items-center"><Logo class="h-14 py-2 text-ffc"/><div class="-mt-4 font-light"><span class="hidden lg:inline-block">&nbsp;- Itinerari</span></div></NuxtLink>
      <Locale/>
  </div>
</template>